// extracted by mini-css-extract-plugin
export default {"carouselItem":"ClaimAgentStep-module-carouselItem-3OrkA","descriptionText":"ClaimAgentStep-module-descriptionText-3rwNx"};